import React from 'react';
import { Box, Typography } from '@mui/material';
import { SettingsProps } from '../../types/props';

export const Settings: React.FC<SettingsProps> = ({ fiscalSponsorId }) => {
  return (
    <Box>
      <Typography variant="h4">Settings</Typography>
    </Box>
  );
}; 